import "./App.css";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {ThemeProvider} from "@mui/material/styles";
import {Layout} from "antd";
import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";

import theme from "./assets/theme";
import {About} from "./component/about/About";
import {Footer} from "./component/Footer/Footer";
import {Intro} from "./component/Intro/Intro";
import {Mobile} from "./component/Mobile/Mobile";
import {Product} from "./component/Product/Product";
import {Recognition} from "./component/Recognition/Recognition";
import {SiteHeader} from "./component/site-header/SiteHeader";
import {SiteHeaderPrivacy} from "./component/site-header-privacy/SiteHeaderPrivacy";
import {SiteHeaderTc} from "./component/site-header-tc/SiteHeaderTc";

export const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route
            path="/t_c"
            element={
              <Layout className="layout">
                <SiteHeaderTc />
                {/* <SiteFooter /> */}
              </Layout>
            }
          />

          <Route
            path="/privacy"
            element={
              <Layout className="layout">
                <SiteHeaderPrivacy />
                {/* <SiteFooter /> */}
              </Layout>
            }
          />

          <Route
            path="/"
            element={
              <Box sx={{background: "white"}}>
                <SiteHeader>
                  <Grid
                    container
                    mt={0}
                    rowSpacing={35}
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={12}>
                      <Intro />
                    </Grid>

                    <Grid item xs={12}>
                      <Product />
                    </Grid>

                    <Grid item xs={12}>
                      <Recognition />
                    </Grid>

                    <Grid item xs={12}>
                      <Mobile />
                    </Grid>

                    <Grid item xs={12}>
                      <About />
                    </Grid>

                    <Grid item xs={12}>
                      <Footer />
                    </Grid>
                  </Grid>
                </SiteHeader>
              </Box>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};
